import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es6.object.freeze";
import React from 'react';
import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 0;\n  width: 0;\n  padding: ", ";\n  border: ", ";\n  border-right-color: #888;\n  border-radius: 50%;\n  animation: rotate 1s infinite linear;\n\n  @keyframes rotate {\n    /* 100% keyframe for  clockwise.\n     use 0% instead for anticlockwise */\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var LoadingContainer = styled.div(_templateObject());
var StyledLoading = styled.div(_templateObject2(), function (_ref) {
  var size = _ref.size;

  if (size === 'large') {
    return '9px';
  } else if (size === 'medium') {
    return '6px';
  }

  return '3px';
}, function (_ref2) {
  var size = _ref2.size;
  var borderSize;

  if (size === 'large') {
    borderSize = '6px';
  } else if (size === 'medium') {
    borderSize = '5px';
  } else {
    borderSize = '4px';
  }

  return "".concat(borderSize, " solid #ccc");
});

var Loading = function Loading(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'small' : _ref3$size;
  return React.createElement(LoadingContainer, null, React.createElement(StyledLoading, {
    size: size
  }));
};

export { Loading };